'use strict';

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-finite");

require("core-js/modules/es6.regexp.split");

var crypto = require('crypto');

var urlSafeCharacters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~'.split('');

var generateForCustomCharacters = function generateForCustomCharacters(length, characters) {
  // Generating entropy is faster than complex math operations, so we use the simplest way
  var characterCount = characters.length;
  var maxValidSelector = Math.floor(0x10000 / characterCount) * characterCount - 1; // Using values above this will ruin distribution when using modular division

  var entropyLength = 2 * Math.ceil(1.1 * length); // Generating a bit more than required so chances we need more than one pass will be really low

  var string = '';
  var stringLength = 0;

  while (stringLength < length) {
    // In case we had many bad values, which may happen for character sets of size above 0x8000 but close to it
    var entropy = crypto.randomBytes(entropyLength);
    var entropyPosition = 0;

    while (entropyPosition < entropyLength && stringLength < length) {
      var entropyValue = entropy.readUInt16LE(entropyPosition);
      entropyPosition += 2;

      if (entropyValue > maxValidSelector) {
        // Skip values which will ruin distribution when using modular division
        continue;
      }

      string += characters[entropyValue % characterCount];
      stringLength++;
    }
  }

  return string;
};

var allowedTypes = [undefined, 'hex', 'base64', 'url-safe'];

module.exports = function (_ref) {
  var length = _ref.length,
      type = _ref.type,
      characters = _ref.characters;

  if (!(length >= 0 && Number.isFinite(length))) {
    throw new TypeError('Expected a `length` to be a non-negative finite number');
  }

  if (type !== undefined && characters !== undefined) {
    throw new TypeError('Expected either `type` or `characters`');
  }

  if (characters !== undefined && typeof characters !== 'string') {
    throw new TypeError('Expected `characters` to be string');
  }

  if (!allowedTypes.includes(type)) {
    throw new TypeError("Unknown type: ".concat(type));
  }

  if (type === undefined && characters === undefined) {
    type = 'hex';
  }

  if (type === 'hex' || type === undefined && characters === undefined) {
    return crypto.randomBytes(Math.ceil(length * 0.5)).toString('hex').slice(0, length); // Need 0.5 byte entropy per character
  }

  if (type === 'base64') {
    return crypto.randomBytes(Math.ceil(length * 0.75)).toString('base64').slice(0, length); // Need 0.75 byte of entropy per character
  }

  if (type === 'url-safe') {
    return generateForCustomCharacters(length, urlSafeCharacters);
  }

  if (characters.length === 0) {
    throw new TypeError('Expected `characters` string length to be greater than or equal to 1');
  }

  if (characters.length > 0x10000) {
    throw new TypeError('Expected `characters` string length to be less or equal to 65536');
  }

  return generateForCustomCharacters(length, characters.split(''));
};